import { CardHeader, Card,CardBody,Row,Col} from "reactstrap";
import { useEffect, useState } from "react";
import { hideMenuTypeBar, hideMenuTypeTabs, hideSchoolDrowdown, showMenuTypeBar, showMenuTypeTabs, showSchoolDrowdown } from "../../../../../actions/menuTypeAction";
import { useMenuTypeDispatch } from "../../../../../context/MenuTypeContext";
import FullCalendar from "@fullcalendar/react";
import daygridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { v4 as uuid } from "uuid";
import './fullCalendarStyles.css';
import { createCalendarHoliday, deleteCalendarHoliday, getCalendarHoliday } from "../../../../../actions/calendarHolidaysAction";
import { useAuthState } from "../../../../../context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { getIdOfRecord } from "../../../../../helpers/utils";

const EventItem = ({ info ,handleDeleteEvent}) => {
  const { event } = info;
  return (
   <div class="fc-event-main-cust">
      <span><span className="fc-daygrid-event-dot"></span>{event.title} 
           
            </span>
             <FontAwesomeIcon
                icon="trash"
                onClick={(e)=>{
                    e.preventDefault()
                    e.stopPropagation()
                    handleDeleteEvent(event)
                }}
              />
      </div>
   
  );
};

const ManageHolidays= () =>{
 const { otherInfo } = useAuthState();
 const dispatch=useMenuTypeDispatch();
  const [events, setEvents] = useState([]);

    useEffect(()=>{
        hideMenuTypeTabs(dispatch);
        hideMenuTypeBar(dispatch);
        return async() => {
            await showMenuTypeTabs(dispatch);
            await showMenuTypeBar(dispatch);
          }
    },[]);
    useEffect(()=>{
         const startDate = moment().startOf("month").format("YYYY-MM-DD")
        const endDate = moment().endOf("month").format("YYYY-MM-DD")
        fetchHolidays(startDate,endDate)
    },[])
    const fetchHolidays =async (startDate,endDate)=>{
        try {  
              const catererId = otherInfo.catererId;
            const payload = {
                startDate,endDate,catererId
            }
            const resp = await getCalendarHoliday(payload)
            console.log(resp)
            const data =resp.data._embedded.catererHolidays
            const events = data.map((item)=>{
                return CalendarEvent(item)
            })
            setEvents(events)
        } catch (error) {
            console.log(error)
        }
    }
    const CalendarEvent = (item)=>{
        const id = getIdOfRecord(item)
       return {
            start : item.date,
            end: item.date,
            title : item.note,
            id : id,
        }
    }

   const handleSelect =async (info) => {
    try{
        const { start, end } = info;
        const startDate = moment(start).format("YYYY-MM-DD")
        const endDate = moment(end).subtract(1, 'day').format("YYYY-MM-DD")
        const eventNamePrompt = prompt("Enter, holiday name");
        const catererId = otherInfo.catererId;
        if (eventNamePrompt) {
            const datesArray = getDateRange(startDate,endDate)
            const fetchAll = datesArray.map(date=> {
                const requestBody =  {
                                "catererId":catererId,
                                "date":date,
                                "note":eventNamePrompt
                            }
            // post event api call
            return createCalendarHoliday(requestBody)
            
            })

           const response = await Promise.all(fetchAll)
           response.map(resp=>{
            const id = getIdOfRecord(resp.data)
            
            events.push( {
                start : resp.data.date,
                // end,
                title: eventNamePrompt,
                id
            })
           
           })
            setEvents([
            ...events,
           
            ]);

        }
    }catch(error){
        console.log(error)
    }
  };
  const getDateRange = (firstDate, lastDate) => {
  if (moment(firstDate, 'YYYY-MM-DD').isSame(moment(lastDate, 'YYYY-MM-DD'), 'day'))
    return [lastDate];
  let date = firstDate;
  const dates = [date];
  do {
    date = moment(date).add(1, 'day');
    dates.push(date.format('YYYY-MM-DD'));
  } while (moment(date).isBefore(lastDate));
  return dates;
};
  const handleMonthChange =    async (event) => {
         console.log('handleMonth change has been been');
       var midDate = new Date((event.start.getTime() + event.end.getTime()) / 2)
        const startDate = moment(midDate).startOf("month").format("YYYY-MM-DD")
        const endDate = moment(midDate).endOf("month").format("YYYY-MM-DD")
        console.log(startDate,endDate)
        fetchHolidays(startDate,endDate)

        
    }
    const handleDeleteEvent = async ( selectedItem) =>{
        try{
           
            console.log(selectedItem)
            await deleteCalendarHoliday(selectedItem.id)
            const filterEvents = events.filter(item => item.id !== selectedItem.id)
            setEvents(filterEvents)
        }catch(error){
            console.log(error)
        }
      
    }
    return ( <div>
              <Card>
                    <CardHeader className='p-2 bg-light'>
                        <Row>
                            <Col><h5>{`Manage Holidays`}</h5></Col>
                            
                        </Row>
                    </CardHeader>
                    <CardBody className='p-2'>
                        <FullCalendar
                            editable
                            selectable
                            events={events }
                            select={handleSelect}
                            headerToolbar={{
                            start: '',
                            center:"prev title next",
                            end: ""
                            }}
                            // eventsSet={(events) => events.map(event=> <EventItem info={event} handleDeleteEvent={handleDeleteEvent}/>) }
                            datesSet={handleMonthChange}
                            eventContent={(info) => <EventItem info={info}  handleDeleteEvent={handleDeleteEvent} />}
                            plugins={[daygridPlugin, interactionPlugin]}
                            views={["dayGridMonth", "dayGridWeek", "dayGridDay"]}
                            
                        />
                    </CardBody>
                    </Card>
                    </div>)
}

export default ManageHolidays